import React from 'react'
import { Link, Text } from '@sketch/components'
import styled from 'styled-components'
import { SKETCH_WEBSITE } from '@sketch/env-config'

const WorkspaceSubscribeRestrictionNoticeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 60px;
`
export function WorkspaceSubscribeRestrictionNotice() {
  return (
    <WorkspaceSubscribeRestrictionNoticeContainer>
      <Text.H1 textStyle="header.primary.I" m={0} textAlign="center">
        Direct Purchase Unavailable
      </Text.H1>
      <Text
        textStyle="copy.tertiary.standard.E"
        mt={2}
        mb={0}
        maxWidth={420}
        textAlign="center"
      >
        Sketch purchases and renewals are unavailable in your region. You may be
        able to purchase{' '}
        <Link
          href={`${SKETCH_WEBSITE}/partners/directory/`}
          external={true}
          variant="tertiary"
        >
          via a partner
        </Link>
        .
      </Text>
    </WorkspaceSubscribeRestrictionNoticeContainer>
  )
}
